import gql from 'graphql-tag'

export const CREATE_MATERIAL = gql`
  mutation CreateMaterial($data: MaterialCreateInput!, $cover: Upload) {
    createMaterial(data: $data, cover: $cover) {
      id
      name
    }
  }
`

export const UPDATE_MATERIAL = gql`
  mutation UpdateMaterial(
    $id: Int!
    $data: MaterialUpdateInput!
    $cover: Upload
  ) {
    updateMaterial(id: $id, data: $data, cover: $cover) {
      id
      name
    }
  }
`

export const DELETE_MATERIAL = gql`
  mutation DeleteMaterial($id: Int!) {
    deleteMaterial(id: $id) {
      id
      name
    }
  }
`

export const UPLOAD_MATERIAL_IMAGE = gql`
  mutation UploadMaterialImage($id: Int!, $file: Upload!) {
    uploadMaterialImage(id: $id, file: $file) {
      uid
      url
      name
      status
    }
  }
`

export const REMOVE_MATERIAL_IMAGE = gql`
  mutation RemoveMaterialImage($id: Int!, $imageId: Int!) {
    removeMaterialImage(id: $id, imageId: $imageId) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/Material.js